import React from 'react';
import style from './index.module.scss';

const NmckSecurityServicesCalculationInfo: React.FC = () => (
  <>
    <h1 className={style.header}>Расчет НМЦК на услуги охраны</h1>
    <div className={style.description}>
      <h2 className={style.descriptionTitle}>Сервис позволяет:</h2>

      <div className={style.descriptionItems}>
        <div className={style.descriptionItem}>
          Обосновать размер НМЦК при закупке услуг охраны с учетом прямых затрат, косвенных расходов, прибыли, НДС и
          индекса инфляции, а также специфики объекта и требований законодательства.
        </div>
      </div>
    </div>
  </>
);

export default NmckSecurityServicesCalculationInfo;
